export default __webpack_public_path__ + "static/media/1981.b361eddf.png";